import { CommonModule, DatePipe } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { ComponentsModule } from 'src/app/components/components.module';

import { ProjectRegisterConfirmationComponent } from './project-register-confirmation.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    ProjectRegisterConfirmationComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule,
    ComponentsModule,
    ReactiveFormsModule,
  ],
  exports: [
    ProjectRegisterConfirmationComponent
  ],
  providers: [
    DatePipe
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ProjectRegisterConfirmationModule { }
